<template>
    <!-- Loading -->
    <div class="vld-parent">
        <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
    </div>

    <form @submit.prevent="store('')" class="form-content">
        <div class="form-content-inner">

            <div class="form-col">
                <field :label="$t('Branch')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                    <control :options="BranchDataList" v-model="branch.branch_id"/>
                </field>
            </div>

            <div class="form-col">
                <control type="hidden" v-model="branch.id" :hasError="!!errors.id" id="id"/>
            </div>

            <div class="buttons-submit transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
                <jb-buttons class="buttons-action-submit">
                    <jb-button type="submit" color="info" :icon="mdiCheckBold" :label="$t('finance.button.btnSubmit')" class="form-submit-btn" />
                    <jb-button type="button" color="info" outline :label="$t('finance.button.btnReset')" class="form-noicon-btn btn-reset" @click="reset()" />
                </jb-buttons>
            </div>
        </div>
    </form>
</template>
<script>
/* eslint-disable */
import { ref, reactive, onMounted, onBeforeMount, watch, watchEffect } from 'vue'
import axios from 'axios'
import { axiosDocument } from "@/boot/axios";
import { mdiBallot, mdiCheckBold, mdiClose } from '@mdi/js'
import { useStore } from 'vuex'
import Control from '@/components/Control'
import { useRouter } from 'vue-router'
import JbButton from '@/components/JbButton'
import JbButtons from '@/components/JbButtons'
import Field from '@/components/Field'
import { useToast } from 'vue-toastification'
import { getBranchData } from '@/composables/global'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main\.css'
import Loading from 'vue-loading-overlay'
export default {
    name: 'ClassForm',
    components: {
        Field,
        Datepicker,
        Control,
        JbButton,
        JbButtons,
        Loading
    },
    props: {
        showEdit: { Boolean },
        propClass: {
            type: Object,
            default: () => ({ empty: true })
        },
        propObject: {
            type: Object,
            default: () => ({ empty: true })
        }
    },
    data: function () {
        return {
        }
    },
    emits: ['close-modal', 'is-new', 'submit', 'refresh-list'],
    setup (props, { emit }) {
        const titleStack = ref(['Admin', 'Forms'])
        const isLoading = ref(false)
        const toast = useToast()
        const router = useRouter()

        const errors = ref([])
        const { BranchDataList } = getBranchData()

        const str = useStore()
        const userlogin = localStorage.getItem('name')

        const branch = reactive({
            id: '',
            branch_id: '',
            branch_name: '',
            created_by: '',
            updated_by: ''
        })

        const store = async (env) => {
            isLoading.value = true
            const url = props.showEdit ? 'employeebranch/' + branch.id : 'employeebranch';
            const method = props.showEdit ? "PUT" : "POST";

            branch.created_by = userlogin
            console.log('branch', branch)

            const jsonData = JSON.stringify(branch)

            const configHeaders = {
                "content-type": "application/json",
                "Accept": "application/json"
            };

            await axios({
                    method,
                    url,
                    data: jsonData,
                    headers: configHeaders
                })
                .then(response => {
                    if (response.data.success) {
                        isLoading.value = false
                        emit('close-modal')
                        emit('refresh-list')
                        toast.success(response.data.message)
                    } else {
                        isLoading.value = false
                        errors.value = response.data.messages
                        toast.error(response.data.messages)
                    }
                })
                .catch(error => {
                    isLoading.value = false
                    console.log(error)
                })
        }

        onBeforeMount(() => {
        })

        onMounted(() => {
            // branch.value =toRefs(props, 'propClass')
        })

        watchEffect(() => {
            const newobject = props.propObject;
            Object.assign(branch, newobject);

            if (!props.showEdit) {
                branch.id = null;
                branch.branch_id = null;
                branch.branch_name = null;
            }

            const newbranch = props.propClass
            branch.submenu = newbranch.submenu
            branch.ein = newbranch.ein
            branch.employee_id = newbranch.employee_id
            branch.nickname = newbranch.nickname
        })
        
        return {
            titleStack,
            mdiBallot,
            mdiCheckBold,
            mdiClose,
            router,
            branch,
            store,
            BranchDataList,
            toast,
            userlogin,
            errors,
            isLoading
        }
    },
    methods: {
        clearForm () {
            this.branch = reactive({
                id: '',
                description: '',
                created_by: ''
            })
        },
    }
}
</script>
